import { render, staticRenderFns } from "./OrderClientNameField.vue?vue&type=template&id=6e131576&scoped=true&"
import script from "./OrderClientNameField.vue?vue&type=script&lang=js&"
export * from "./OrderClientNameField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e131576",
  null
  
)

export default component.exports